import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import WorkflowEventCodeTaskModel from '../../../models/WorkflowEventCodeTaskModel';
import WorkflowStepDefinitionModel from '../../../models/WorkflowStepDefinitionModel';
import DataService from "../../../services/data.service";
import Workflow_popup_AddEventCodeTask from "../Popups/Workflow_popup_AddEventCodeTask"

export type Props = {
    workflowDefinitionId: number
}

const Workflow_tab_EventCodeTasks: React.FC<Props> = ({ workflowDefinitionId }) => {
    const [data, setData] = useState<WorkflowEventCodeTaskModel[]>();
    const { handleResult, handleException } = useNotifications();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { isAuthorizedForWorkflowDefinition } = useAuth();

    useEffect(() => {
        getTableData();
    }, [workflowDefinitionId]);

    function getTableData() {
        DataService.get<WorkflowEventCodeTaskModel[]>('api/v1/WorkflowEventCodeTasks/ByWorkflowDefinition/' + workflowDefinitionId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function canDeleteRow(rowData: WorkflowStepDefinitionModel): boolean {
        return isAuthorizedForWorkflowDefinition(ApplicationFunctions.UpdateWorkflowDefinition, rowData.workflowDefinitionId)
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/WorkflowEventCodeTasks/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    return (
        <>
            <DataTable
                name='dtWorkflowEventCodeTasks'
                tableData={data}
                navigateTitle='Event code task'
                navigateUrl='/plm/WorkflowSetup/WorkflowEventCodeTask/'
                colInfos={[
                    { key: true, dataProp: 'id', visible: false },
                    { title: 'Event type', dataProp: 'workflowEventType.name' },
                    { title: 'Execution order', dataProp: 'executionOrder', sort: 'asc' },
                    { title: 'Code task', dataProp: 'codeTaskName' },
                    {
                        headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true), applicationFunctions: [ApplicationFunctions.UpdateWorkflowDefinition] }],
                        rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, isVisible: canDeleteRow }]
                    }
                ]}
            />
            {showPopup && <Workflow_popup_AddEventCodeTask show={showPopup} onHide={() => { getTableData(); setShowPopup(false) }} workflowDefinitionId={workflowDefinitionId} />}
        </>
    );
}
export default Workflow_tab_EventCodeTasks;